import GeoJSON, { GeoJSONGeometry, GeoJSONGeometryCollection, GeoJSONFeature } from 'ol/format/GeoJSON';
import Geometry from 'ol/geom/Geometry';
import Feature from 'ol/Feature';

export const geoJSONFormatter = new GeoJSON();

/**
 * convert a text to geometry
 * @param {string} geometryText geometry as text
 * @returns {Geometry}
 */
export function geometryFromGeojsonText(geometryText: string): Geometry {
  return geoJSONFormatter.readGeometry(geometryText);
}


/**
 * convert a texr/object to geometry
 * @param {string | object | ArrayBuffer | Document | Node} geometry 
 * @returns {Geometry}
 */
 export function geometryFromGeojson(geometry: string | object | ArrayBuffer | Document | Node): Geometry {
  return geoJSONFormatter.readGeometry(geometry);
}

/**
 * convert a text to feature
 * @param {string} featureText feature as text
 * @returns {Feature<Geometry>}
 */
export function featureFromGeojsonText(featureText: string): Feature<Geometry> {
  return geoJSONFormatter.readFeature(featureText);
}

/**
 * convert a text to features
 * @param {string} featuresText features as text
 * @returns {Feature<Geometry>[]}
 */
export function featuresFromGeojsonText(featuresText: string): Array<Feature<Geometry>> {
  return geoJSONFormatter.readFeatures(featuresText);
}

/**
 * convert a feature to geometry
 * @param {Geometry} geometry geometry as text
 * @returns {GeoJSONGeometry | GeoJSONGeometryCollection}
 */
export function geometryObjectFromGeometry(geometry: Geometry): GeoJSONGeometry | GeoJSONGeometryCollection {
  return geoJSONFormatter.writeGeometryObject(geometry);
}

/**
 * convert a GeoJSON Geometry in a Feature
 * @param {GeoJSONGeometry | GeoJSONGeometryCollection} geometryObject geoJSON Geometry
 * @param {any} properties props for the feature
 * @returns {GeoJSONFeature} Geometry wrapped in a Feautre with properties
 */
export function wrapGeometryObject(geometryObject: GeoJSONGeometry | GeoJSONGeometryCollection, properties: any): GeoJSONFeature {
  const geometry = geoJSONFormatter.readGeometry(geometryObject);
  const feature = new Feature(properties);
  feature.setGeometry(geometry);

  return geoJSONFormatter.writeFeatureObject(feature);
}
